// extracted by mini-css-extract-plugin
module.exports = {"button":"FeaturedCommentTooltip-button-ba89e13064b0e0a3c4016683889d64d7"};